// extracted by mini-css-extract-plugin
export default {"cardsView":"cardsDisplayMode_cardsView__JCefh","select":"cardsDisplayMode_select__drglV","label":"cardsDisplayMode_label__wA0MM"};